export default __webpack_public_path__ + "static/media/tituloES.ae9fe207.png";